import { render, staticRenderFns } from "./symbolLogo.vue?vue&type=template&id=6ae17316&scoped=true&"
import script from "./symbolLogo.vue?vue&type=script&lang=js&"
export * from "./symbolLogo.vue?vue&type=script&lang=js&"
import style0 from "./symbolLogo.vue?vue&type=style&index=0&id=6ae17316&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae17316",
  null
  
)

export default component.exports